(function(){
"use strict";
var $=function(s,r){return (r||document).querySelector(s)},G=window.GG||{};
function money(c){return new Intl.NumberFormat("en-GB",{style:"currency",currency:G.currency||"GBP"}).format(c/100)}
function esc(s){return String(s==null?"":s).replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}

/* ---------- Delivery estimate (3-7 UK working days, per shipping policy) ---------- */
var HOL=["2026-12-25","2026-12-28","2027-01-01","2027-04-02","2027-04-05","2027-05-03","2027-05-31","2027-08-30","2027-12-27","2027-12-28"];
function addWorking(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var k=d.toISOString().slice(0,10),w=d.getDay();if(w!==0&&w!==6&&HOL.indexOf(k)<0)n--;}return d}
function fmt(d){return d.toLocaleDateString("en-GB",{weekday:"short",day:"numeric",month:"short"})}
var price=$(".pp-price");
if(price&&!$(".gzb-eta")){
  var now=new Date(),a=addWorking(now,3),b=addWorking(now,7);
  var eta=document.createElement("p");eta.className="gzb-eta";
  eta.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg><span>Free UK delivery · Order today, estimated arrival <strong>'+fmt(a)+' – '+fmt(b)+'</strong></span>';
  price.insertAdjacentElement("afterend",eta);
}

/* ---------- Sticky add-to-bag bar (product page) ---------- */
var pf=$("[data-product-form]"),addBtn=$("#ppAdd");
if(pf&&addBtn){
  var img=$("#ppMain"),title=($(".pp-info h1")||{}).textContent||"";
  var bar=document.createElement("div");bar.className="gzb-sticky";bar.setAttribute("aria-hidden","true");
  bar.innerHTML='<div class="gzb-sticky-in">'+(img?'<img src="'+(img.currentSrc||img.src)+'" alt="">':'')+'<div class="gzb-st-t"><span class="gzb-st-name">'+esc(title)+'</span><span class="gzb-st-price"></span></div><button type="button" class="btn btn-gold gzb-st-btn">Add to bag</button></div>';
  document.body.appendChild(bar);
  var stPrice=$(".gzb-st-price",bar),stBtn=$(".gzb-st-btn",bar);
  function syncBar(){stPrice.textContent=($("#ppPrice")||{}).textContent||"";stBtn.disabled=addBtn.disabled;stBtn.textContent=addBtn.disabled?"Sold out":"Add to bag";}
  syncBar();pf.addEventListener("change",function(){setTimeout(syncBar,30)});
  stBtn.addEventListener("click",function(){if(pf.requestSubmit)pf.requestSubmit();else addBtn.click();});
  if("IntersectionObserver" in window){
    new IntersectionObserver(function(es){var e=es[0],show=!e.isIntersecting&&e.boundingClientRect.top<0;bar.classList.toggle("show",show);bar.setAttribute("aria-hidden",String(!show));syncBar();}).observe(addBtn);
  }
}

/* ---------- Cart drawer: progress bar + "complete your bundle" picks ---------- */
var nudge=$("#nudge"),drawer=$("#drawer");
if(nudge&&drawer){
  var prog=document.createElement("div");prog.className="gzb-prog";prog.innerHTML='<div class="gzb-prog-bar"><i></i></div>';
  nudge.insertAdjacentElement("afterend",prog);
  var recos=document.createElement("div");recos.className="gzb-recos";
  var tot=$("#totals");tot.insertAdjacentElement("beforebegin",recos);
  var busy=false,lastKey="";
  async function refresh(){
    if(busy)return;busy=true;
    try{
      var c=await (await fetch((G.routes&&G.routes.cart||"/cart")+".js",{headers:{Accept:"application/json"}})).json();
      var min=G.min||2,pct=Math.min(100,Math.round(c.item_count/min*100));
      prog.querySelector("i").style.width=pct+"%";prog.classList.toggle("done",c.item_count>=min);prog.hidden=c.item_count===0;
      if(!c.item_count){recos.innerHTML="";lastKey="";return}
      var key=c.items.map(function(i){return i.product_id}).join(",");if(key===lastKey)return;lastKey=key;
      var inCart=c.items.map(function(i){return i.product_id});
      var r=await (await fetch((G.routes&&G.routes.root||"/")+"recommendations/products.json?product_id="+c.items[0].product_id+"&limit=6&intent=related")).json();
      var list=(r.products||[]).filter(function(p){return p.available&&inCart.indexOf(p.id)<0}).slice(0,3);
      if(!list.length){recos.innerHTML="";return}
      var head=c.item_count<min?"Add one more to unlock "+Math.round((G.rate||.2)*100)+"% off":"You might also like";
      recos.innerHTML='<p class="gzb-recos-h">'+head+'</p><div class="gzb-recos-l">'+list.map(function(p){var v=p.variants.find(function(x){return x.available})||p.variants[0];var im=p.featured_image?String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i,"_160x$1$2"):"";return '<div class="gzb-reco">'+(im?'<a href="'+p.url+'"><img src="'+im+'" alt="" loading="lazy"></a>':'')+'<a class="gzb-reco-t" href="'+p.url+'">'+esc(p.title)+'</a><span class="gzb-reco-p">'+money(v.price)+'</span><button type="button" class="btn btn-line btn-sm" data-add-variant="'+v.id+'" data-title="'+esc(p.title)+'">Add</button></div>'}).join("")+'</div>';
    }catch(e){}finally{busy=false}
  }
  var tm;function later(){clearTimeout(tm);tm=setTimeout(refresh,400)}
  new MutationObserver(later).observe(nudge,{childList:true,characterData:true,subtree:true});
  new MutationObserver(later).observe(drawer,{attributes:true,attributeFilter:["class"]});
  later();
}

/* ---------- Seasonal search chip: Halloween -> Christmas ---------- */
var sr=$("#searchResults");
if(sr){new MutationObserver(function(){var b=sr.querySelector('[data-fill="halloween"]');if(b){b.dataset.fill="christmas gifts";b.textContent="Christmas gifts";}}).observe(sr,{childList:true,subtree:true});}

/* ---------- Secure payment panel under the buy buttons (uses real enabled methods) ---------- */
(function(){
  var form=document.querySelector("[data-product-form]"),src=document.querySelector(".gzp-trust .gzp-pay");
  if(!form||!src||document.querySelector(".gzb-pay"))return;
  var order=["visa","master","american_express","maestro","apple_pay","google_pay","shopify_pay","klarna","paypal"];
  var icons={};src.querySelectorAll("svg").forEach(function(s){var id=(s.getAttribute("aria-labelledby")||"").replace("pi-","");icons[id]=s});
  var box=document.createElement("div");box.className="gzb-pay";
  box.innerHTML='<div class="gzb-payhead"><b><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Secure checkout</b><span>256-bit SSL · powered by Shopify</span></div><div class="gzb-cards"></div>';
  var row=box.querySelector(".gzb-cards");
  order.forEach(function(k){if(icons[k])row.appendChild(icons[k].cloneNode(true))});
  if(icons.klarna){var k=document.createElement("div");k.className="gzb-klarna";k.innerHTML='<i>Klarna.</i><span>Prefer to <strong>pay later?</strong> Choose Klarna at checkout.</span>';box.appendChild(k)}
  if(row.children.length)form.insertAdjacentElement("afterend",box);
})();

/* ---------- Replace Shop-branded dynamic button with a single "Buy it now" that goes straight to checkout ---------- */
(function(){
  var form=document.querySelector("[data-product-form]"),add=document.querySelector("#ppAdd");
  if(!form||!add||document.querySelector(".gzb-buynow"))return;
  var btn=document.createElement("button");btn.type="button";btn.className="btn gzb-buynow";
  btn.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2L4 14h7l-1 8 9-12h-7z"/></svg><span>Buy it now</span>';
  var row=form.querySelector(".row");(row||add).insertAdjacentElement("afterend",btn);
  function sync(){btn.disabled=add.disabled}sync();form.addEventListener("change",function(){setTimeout(sync,30)});
  btn.addEventListener("click",async function(){
    if(btn.disabled)return;btn.classList.add("busy");btn.querySelector("span").textContent="Taking you to checkout…";
    try{
      var fd=new FormData(form);
      var r=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart/add.js",{method:"POST",body:fd,headers:{Accept:"application/json"}});
      if(!r.ok)throw new Error("add");
      window.location.href="/checkout";
    }catch(e){btn.classList.remove("busy");btn.querySelector("span").textContent="Please try again"}
  });
})();
})();
